import { LOCAL_STORAGE_KEYS, QUERY_PARAM_KEYS } from '$lib/utils/constants';
import { AnalyticsService } from './index';

/**
 * Returns analytics identifiers from localStorage, defaulting to null if absent.
 * @returns {{
 *   adid: string|null,
 *   idfa: string|null,
 *   idfv: string|null,
 *   gps_adid: string|null,
 *   android_id: string|null,
 *   app_instance_id: string|null
 * }}
 */
export function getAnalyticsIdentifiers() {
	return {
		adid: localStorage.getItem(LOCAL_STORAGE_KEYS.ADID) ?? null,
		idfa: localStorage.getItem(LOCAL_STORAGE_KEYS.IDFA) ?? null,
		idfv: localStorage.getItem(LOCAL_STORAGE_KEYS.IDFV) ?? null,
		gps_adid: localStorage.getItem(LOCAL_STORAGE_KEYS.GPS_ADID) ?? null,
		android_id: localStorage.getItem(LOCAL_STORAGE_KEYS.ANDROID_ID) ?? null,
		app_instance_id: localStorage.getItem(LOCAL_STORAGE_KEYS.APP_INSTANCE_ID) ?? null
	};
}

/**
 * Persists supported analytics identifiers from query params to localStorage (if present).
 */
export function setAllAnalyticsIdentifiersFromQuery() {
	try {
		const searchParams = new URLSearchParams(location.search);
		const keyMap = [
			[QUERY_PARAM_KEYS.UDID, LOCAL_STORAGE_KEYS.UDID],
			[QUERY_PARAM_KEYS.ADID, LOCAL_STORAGE_KEYS.ADID],
			[QUERY_PARAM_KEYS.IDFA, LOCAL_STORAGE_KEYS.IDFA],
			[QUERY_PARAM_KEYS.IDFV, LOCAL_STORAGE_KEYS.IDFV],
			[QUERY_PARAM_KEYS.GPS_ADID, LOCAL_STORAGE_KEYS.GPS_ADID],
			[QUERY_PARAM_KEYS.ANDROID_ID, LOCAL_STORAGE_KEYS.ANDROID_ID],
			[QUERY_PARAM_KEYS.APP_INSTANCE_ID, LOCAL_STORAGE_KEYS.APP_INSTANCE_ID]
		];
		for (const [queryKey, storageKey] of keyMap) {
			const value = searchParams.get(queryKey);
			if (value) {
				localStorage.setItem(storageKey, value);

				AnalyticsService.trackClientDebug({
					source: 'getAnalyticsIdentifiers.setAllAnalyticsIdentifiersFromQuery',
					href: location.href,
					search: location.search,
					key: queryKey,
					value: value
				});
			}
		}
	} catch (e) {
		console.error('Error setting all analytics identifiers from query', e);
	}
}
